import { useState, useEffect } from 'react';

const useUtagLoaded = (intervalTime = 500) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const checkUtagLoaded = () => {
      return typeof window.utag !== 'undefined';
    };

    const intervalId = setInterval(() => {
      if (checkUtagLoaded()) {
        setIsLoaded(true);
        clearInterval(intervalId);
      }
    }, intervalTime);

    return () => clearInterval(intervalId);
  }, [intervalTime]);

  return isLoaded;
};

export default useUtagLoaded;
